module.exports = __webpack_public_path__ + "static/media/marketing-icon-inactive.4cc6caf7.svg";